"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetProbeHintService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const probeHint_1 = require("./probeHint/probeHint");
const service_VersetBusinessGuide_1 = require("./service.VersetBusinessGuide");
const service_VersetProbe_1 = require("./service.VersetProbe");
const service_VersetStickyNotification_1 = require("./service.VersetStickyNotification");
const probeHintName = "probe";
let VersetProbeHintService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetProbeHintService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetBusinessGuideService: service_VersetBusinessGuide_1.VersetBusinessGuideService,
                VersetProbeService: service_VersetProbe_1.VersetProbeService,
                VersetStickyNotificationService: service_VersetStickyNotification_1.VersetStickyNotificationService,
            });
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetProbeHintService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        async initialize() {
            this.deps.VersetProbeService.probeSessionManager.events.listenBy(this, "change", () => {
                // Discovery emits change while applying its own results. Observing
                // that event must not request another discovery pass.
                this.refresh();
            });
            this.refresh();
        }
        refresh() {
            const [, reason] = this.deps.VersetProbeService.getTerminalFileSystemBindings();
            if (reason !== "NoProbeSetup") {
                this.deps.VersetStickyNotificationService.remove(probeHintName);
                return;
            }
            const hint = new probeHint_1.ProbeHint();
            hint.onOpenGuide = () => { void this.deps.VersetBusinessGuideService.handleNoProbeSetup(); };
            this.deps.VersetStickyNotificationService.showWidget({
                name: probeHintName,
                widget: hint,
            });
        }
        destroy() {
            this.deps.VersetProbeService.probeSessionManager.events.stopListenBy(this);
        }
    };
    return VersetProbeHintService = _classThis;
})();
exports.VersetProbeHintService = VersetProbeHintService;
